import { StyleSheet } from "react-native";
import { height, width } from "../../utils/utils";
export const styles = StyleSheet.create({
  viewBackground: {
    height: 106,
    backgroundColor: "#CCE4FF",
    justifyContent: "center",
  },
  textBackground: {
    fontSize: 20,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginLeft: 10,
    alignSelf: "flex-end",
    position: "absolute",
    paddingRight: 29,
  },
  viewTitle: {
    height: 78,
    backgroundColor: "#FFFFFF",
    justifyContent: "center",
  },
  textTitle: {
    fontSize: 30,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    paddingLeft: 30,
  },
});
export const stylesResponsive = StyleSheet.create({
  textTitle: {
    fontSize: 22,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    paddingHorizontal: 30,
  },
  viewTitle: {
    minHeight: 78,
    backgroundColor: "#FFFFFF",
    justifyContent: "center",
  },
});
